module.exports = __webpack_public_path__ + "91c0cc951477ac7e6db373711b63e5c0.svg";